import './App.css'

import IdeExam from './components/IdeExam'

// Replace your code here
const App = () => <IdeExam />

export default App
